import clsx from "clsx";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { FocusRing } from "@/components/Layout/BaseLayouts/Footer/FocusRing";
import { getLegalLinksForFooter } from "@/utils/navigation/legalLinks.tsx";

const linkItemClassName =
  "group relative w-fit rounded-md p-2 text-xs font-semibold text-foreground-primary-inverse hover:bg-surface-secondary-inverse focus:outline-none active:bg-surface-secondary-inverse";

/**
 * This component is used to display a horizontal link menu in the footer.
 * The link items are displayed side-by-side and are always visible.
 **/
export const LinkMenu = () => {
  const { t } = useTranslation();
  const menuItems = useMemo(() => getLegalLinksForFooter(t), [t]);

  return (
    <nav
      aria-label={t("Footer.linksNavAriaLabel")}
      className="flex flex-col items-start justify-between gap-2 pb-6 tablet:flex-row tablet:justify-normal tablet:pb-0"
    >
      {menuItems.map(({ label, link, onClick }) =>
        onClick ? (
          <button
            key={label}
            type="button"
            onClick={onClick}
            className={clsx(linkItemClassName, "!font-semibold")}
          >
            {label}
            <FocusRing inverted />
          </button>
        ) : (
          <a
            key={label}
            href={link}
            target="_blank"
            rel="noreferrer"
            className={linkItemClassName}
          >
            {label}
            <FocusRing inverted />
          </a>
        ),
      )}
    </nav>
  );
};
